import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import { Grid2 } from '@mui/material';

function PhotosFinish({ setProgressOpen, setTutorialStep }) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      sx={{ width: '80%', margin: 'auto' }}
      open={open}
      onClose={handleClose}
      PaperProps={{ style: { maxWidth: 'none' } }}
    >
      <Box style={{ padding: '30px' }}>
        <DialogTitle style={{ marginBottom: '15px' }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            color="primary"
            style={{ position: 'absolute', right: 30, top: 20 }}
            size="large"
          >
            <CloseIcon />
          </IconButton>
          <Grid2 container direction="column" alignItems="center">
            <Grid2 item style={{ marginBottom: '8px' }}>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '600',
                  fontSize: '1.3rem',
                }}
              >
                Parabéns!
              </Typography>
            </Grid2>
            <Grid2 item>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '800',
                  fontSize: '2.5rem',
                }}
              >
                Você concluiu &apos;Fotos&apos;
              </Typography>
            </Grid2>
          </Grid2>
        </DialogTitle>
        <Typography
          paragraph
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Agora você pode optar em continuar o tour guiado ou se preferir pode
          escolher qualquer uma das opções do menu &apos;Tour Rápido&apos; e
          fazer o seu próprio tour personalizado conforme sua necessidade.
        </Typography>
        <Typography
          paragraph
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Fique à vontade para escolher como deseja seguir.
        </Typography>
        <Grid2 container justifyContent="space-between">
          <Grid2 item style={{ margin: '25px 0 15px 0' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: '1rem', minWidth: '12em' }}
              onClick={() => {
                navigate(`/constructions/tour/documents`);
                setTutorialStep(17);
              }}
            >
              Continuar &gt;
            </Button>
          </Grid2>
          <Grid2 item style={{ margin: '25px 0 15px 0' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: '1rem', minWidth: '15em' }}
              onClick={() => {
                setProgressOpen(true);
                handleClose();
              }}
            >
              Explorar Tour Rápido &gt;
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Dialog>
  );
}

PhotosFinish.propTypes = {
  setTutorialStep: PropTypes.func.isRequired,
  setProgressOpen: PropTypes.func.isRequired,
};

export default PhotosFinish;
